import { createEvent, sample } from 'effector'
import { markNoContentPageActive } from '~/processes/no-content-block/model'

export const init = createEvent()

sample({
  clock: init,
  target: markNoContentPageActive,
})
